import { useEffect, useState } from 'react';

import { getShortBirthday } from 'utils/birthdayUtils';

/**
 * React hook to augment Honeydew TextField for birthday input in a MM/DD/YYYY format.
 * @param {string} initialValue - The customer's stored birthday, in a yyyy-dd-mm format.
 * @example
 * const { birthdayFieldValue, birthdayFieldProps } = useBirthdayField(subscription?.dateOfBirth);
 * return (
 *   <TextField name="birthday" inputValue={birthdayFieldValue} {...birthdayFieldProps}  />
 * )
 */

function useBirthdayField(initialValue = '') {
    const [value, setValue] = useState('');

    useEffect(() => {
        if (initialValue) {
            setValue(getShortBirthday(initialValue));
        }
    }, [initialValue]);

    const onChange = (e) => {
        const { value: inputValue } = e.target;
        if (inputValue.length === 0) return setValue('');
        if (inputValue.length < value.length) return setValue(inputValue);
        const digits = inputValue.replace(/\D/g, '');
        const slashed = [...digits].reduce(
            (string, item, index) => `${string}${item}${index === 1 || index === 3 ? '/' : ''}`,
            ['']
        );
        return setValue(slashed);
    };

    return {
        birthdayFieldValue: value,
        birthdayFieldProps: {
            onChange,
            placeholder: 'MM/DD/YYYY',
            maxLength: 10,
            label: 'Birthday',
            autoComplete: 'off',
            required: true,
        },
    };
}

export default useBirthdayField;
